import api from '../instance';
import {
  IMyUser,
  ICommunityCategory,
  ICommunityQuestion,
  ICommunityAnswer,
  IAttachment,
} from '../../store/types/community';

export interface IFetchMyUserParams {
  user_id: string;
}

type TFetchMyUserResponse = {
  data: IMyUser;
};

type TFetchCategoriesResponse = {
  data: ICommunityCategory[];
};

export interface IFetchMyQuestionsParams {
  user_id: string;
  per_page?: number;
  page?: number;
  order_by_direction?: string;
  order_by?: string;
}

export interface IFetchQuestionsParams {
  user_id?: string;
  category?: string;
  per_page?: number;
  page?: number;
  order_direction?: string;
  order_by?: string;
}

type TFetchQuestionsResponse = {
  data: ICommunityQuestion[];
  meta: {
    total: number;
  };
};

export interface IFetchQuestionParams {
  user_id: string;
}

type TFetchQuestionResponse = {
  data: ICommunityQuestion;
};

export interface ISendQuestionData {
  user_id: string;
  category_slug: string;
  title: string;
  question: string;
  anonymously: boolean;
  first_name?: string;
  last_name?: string;
  attachments?: IAttachment[];
}

type TSendQuestionResponse = {
  data: ICommunityQuestion;
};

export interface IUpdateQuestionData {
  user_id: string;
  correct_answer_uuid?: string;
  category_slug?: string;
  title?: string;
  question?: string;
  anonymously?: boolean;
  first_name?: string;
  last_name?: string;
  attachments?: IAttachment[];
}

type TUpdateQuestionResponse = {
  data: ICommunityQuestion;
};

export interface ISendAnswerData {
  user_id: string;
  question_uuid: string;
  first_name: string;
  last_name: string;
  answer: string;
  parent_uuid?: string;
  attachments?: IAttachment[];
}

type TSendAnswerResponse = {
  data: ICommunityAnswer;
};

export interface IVoteQuestionData {
  like: boolean;
  user_id: string;
}

type TVoteQuestionResponse = {
  data: ICommunityQuestion;
};

export interface IVoteAnswerData {
  like: boolean;
  user_id: string;
}

type TVoteAnswerResponse = {
  data: ICommunityAnswer;
};

export interface IUploadAttachmentData {
  file: string;
  name: string;
  extension: string;
  size: number;
}

type TUploadAttachmentResponse = IAttachment;

export default {
  getMyUser: (params: IFetchMyUserParams): Promise<TFetchMyUserResponse> =>
    api.get('community-forum/user/me', { params }),
  getCategories: (): Promise<TFetchCategoriesResponse> => api.get('community-forum/category'),
  getMyQuestions: (params: IFetchMyQuestionsParams): Promise<TFetchQuestionsResponse> =>
    api.get('community-forum/question/me', { params }),
  getQuestions: (params: IFetchQuestionsParams): Promise<TFetchQuestionsResponse> =>
    api.get('community-forum/question', { params }),
  getQuestion: (uuid: string, params: IFetchQuestionParams): Promise<TFetchQuestionResponse> =>
    api.get(`community-forum/question/${uuid}`, { params }),
  sendQuestion: (data: ISendQuestionData): Promise<TSendQuestionResponse> =>
    api.post('community-forum/question', data),
  updateQuestion: (uuid: string, data: IUpdateQuestionData): Promise<TUpdateQuestionResponse> =>
    api.put(`community-forum/question/${uuid}`, data),
  sendAnswer: (data: ISendAnswerData): Promise<TSendAnswerResponse> =>
    api.post('community-forum/answer', data),
  voteQuestion: (uuid: string, data: IVoteQuestionData): Promise<TVoteQuestionResponse> =>
    api.post(`community-forum/question/${uuid}/vote`, data),
  voteAnswer: (uuid: string, data: IVoteAnswerData): Promise<TVoteAnswerResponse> =>
    api.post(`community-forum/answer/${uuid}/vote`, data),
  uploadAttachment: (data: IUploadAttachmentData): Promise<TUploadAttachmentResponse> =>
    api.post('community-forum/attachment', data),
  viewQuestion: (uuid: string): Promise<void> =>
    api.put(`community-forum/question/${uuid}/increase-views`),
};
